import { ApiOptions } from '../../api-options.decorator';
import { DefaultParams } from '../../default-params.model';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseUser } from './base';

/**
 * @internal
 */
export class ApiUserContact extends ApiBaseUser {
  @ApiOptions({ channel: 'user.patch' })
  editUser(userId: number, params: ParamsAdapter) {
    return this.patch(`/user-2.52/contact/${userId}`, params);
  }

  @ApiOptions({ channel: 'user.post', interceptErrors: false })
  createUser(params: ParamsAdapter) {
    return this.post(`/user-2.52/contact`, params);
  }

  @ApiOptions({ channel: 'user.get' })
  getUser(id: number, params: ParamsAdapter = new DefaultParams()) {
    return this.get(`/user-2.52/contact/${id}`, params);
  }

  @ApiOptions({ channel: 'user.list' })
  getUsers(params: ParamsAdapter = new DefaultParams()) {
    return this.get('/user-2.52/contact', params);
  }

  @ApiOptions({ returnedFields: ['id', 'okta_login', 'firstname', 'lastname', 'grants'], channel: 'internalContacts' })
  getInternalContacts() {
    return this.getUsers(new DefaultParams({ type: 'internal' }));
  }

  @ApiOptions({ channel: 'internalContacts', responseType: 'blob' })
  getAvatar(id: number) {
    return this.get<Blob>(`/user-2.52/contact/${id}/avatar`);
  }

  @ApiOptions({ channel: 'contactActivatePost' })
  activateUser(id: number) {
    return this.post(`/user-2.52/contact/${id}/activate`);
  }

  @ApiOptions({ channel: 'contactActivatePost' })
  deActivateUser(id: number) {
    return this.post(`/user-2.52/contact/${id}/deactivate`);
  }

  patchContactExternalAccounts(contactId: number, externalAccounts: { account_id: number }[]) {
    return this.patch(`/user-2.52/contact/${contactId}`, new DefaultParams({ externalAccounts }));
  }
}
